import { render, staticRenderFns } from "./SelectWithProvider.html?vue&type=template&id=45ea3a33&external"
import script from "./SelectWithProvider.vue?vue&type=script&lang=js"
export * from "./SelectWithProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports